import Vue from "vue";
import Vuex from "vuex";
import actions from "./actions.js";
import mutations from "./mutations.js";
import getters from "./getters.js";

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    user: null,
    category: [],
    categoryValue: [],
    usersList: [],
    search: false,
    loading: false,
    error: null,
    products: [],
    cart: [],
    vendorsList: []
  },
  mutations,
  actions,
  getters
});

export default store;
